module.exports = __webpack_public_path__ + "static/media/usa_stores.a9ca7f5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/benefits/usa_stores.png
// module id = 1970
// module chunks = 0